import React, { type ComponentProps, memo } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { Icon } from '@garnish/core';

import { IMAGE_SIZE } from '../../IngredientListItem.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemIcon = memo((props: Props) => {
  const { name } = props;

  return (
    <View style={styles.container}>
      <Icon name={name} width={32} height={32} />
    </View>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    borderRadius: IMAGE_SIZE,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  name: ComponentProps<typeof Icon>['name'];
};
